import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegistrationStepService } from "../registration-step.service";
import { QuestionRequest } from "../models/question-request.model";
import { MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/loader/loader.component";
import { ActionSheetController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { Subject } from "rxjs";

@Component({
  selector: "app-qs-pap",
  templateUrl: "./qs-pap.component.html",
  styleUrls: ['../registration-step.component.scss']
})
export class QsPAPComponent implements OnInit {
  questionCode: string = 'Q_PAP';
  @Input() activeLang: string = "";
  @Input() ocrToBeDone: boolean;
  questionRequest: QuestionRequest;
  progressSpinnerDialog: any = null;
  @Output() proceedNext = new EventEmitter();
  @Output() routeToCertEntry = new EventEmitter();
  uploadFileVisible: boolean = false;
  secondUploadFileVisible: boolean = false;
  selectDocumentType: boolean = false;
  selectDocumentType2: boolean = false;
  selectedDocumentType: string;
  otherDocumentType: string = '';
  selectedOwnerDocumentType: string = '';
  isPropertyOwner: string = '';
  showPropertyOwnerQuestion: boolean = false;
  showOwnerDocumentUpload: boolean = false; // second upload
  isPapVerified: boolean = false;
  showPAPTextBox: boolean = false;
  reUploadFileVisible: boolean = false;
  selectedImage: string = '';
  errorMessageVisible: boolean = false;
  errorMessage: string = '';
  proceedEnabled: boolean = false;
  ocrStatus: boolean = false;
  ocrEntryKey: number;
  selectedRadioOption: string;
  dirtyForm: boolean = false;
  callOcr: Subject<File> = new Subject();
  pmayPattern: string = "^PMAY/\\d{4}-\\d{2}/\\d+$";
  registrationNo: string = "";
  firstSelectedImage: string = '';
  secondSelectedImage: string = '';
  applicantFileBase64: string | null = null;
  ownerFileBase64: string | null = null;


  constructor(private registrationStepService: RegistrationStepService, private dialog: MatDialog,
    public actionSheetController: ActionSheetController, private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    if (localStorage.getItem("editQuestionCode") && localStorage.getItem("editQuestionCode") === this.questionCode) {
      this.displayProgressSpinner();
      this.registrationStepService.fetchQuestionDetail(this.questionCode)
        .subscribe((data) => {
          this.closeProgressSpinner();
          if (data.status === 'SUCCESS') {
            if (data.projectAffectedPeopleResponse) {
              const resp = data.projectAffectedPeopleResponse;

              this.selectedRadioOption = resp.answer;
              // this.selectedOwnerDocumentType = 'DEATH_CERTIFICATE';

              if (this.selectedRadioOption === 'Yes') {
                // ✅ RESTORE REGISTRATION NUMBER
                this.registrationNo = resp.registrationNo || '';
                this.isPropertyOwner = resp.isPropertyOwner;
                this.selectedDocumentType = resp.selectedDocumentType;
                this.otherDocumentType = resp.otherPAPDocumentType;
                this.selectedOwnerDocumentType = resp.selectedDocumentType2;
                this.registrationNo = this.registrationNo.toUpperCase();
                 this.fetchPAPCertificate();

                if (this.isPropertyOwner === 'Not A Property Owner') {
                  this.secondUploadFileVisible = true;
                  this.selectDocumentType2 = true;
                }

                // ✅ SHOW TEXTBOX
                this.showPAPTextBox = true;

                // ✅ TRIGGER VALIDATION & UI FLOW
                if (this.registrationNo) {
                  this.onPAPRegistrationNumberChange();
                }
               
              }



              // Re-evaluate proceed button
              this.evaluateProceed();
            }

            else {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }
          }
          else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }
        }, error => {
          this.closeProgressSpinner();
          this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
        });
    }
    else {
      localStorage.removeItem("editQuestionCode");
      this.proceedNext.emit();
    }
  }

  onPAPRegistrationNumberChange() {
    this.registrationNo = this.registrationNo.toUpperCase(); // 🔥 new line for uppercase always

    this.errorMessageVisible = false;
    this.errorMessage = '';

    if (this.registrationNo && this.registrationNo.trim().length > 0) {
      this.registrationStepService.validatePAPRegistrationNumber(this.registrationNo)
        .subscribe((response: any) => {
          if (response.status === 'SUCCESS' && response.exists) {
            this.isPapVerified = true;
            this.showPropertyOwnerQuestion = true;
            this.errorMessageVisible = false;
             this.rebuildPAPUIForEdit();
          } else {
            this.showPropertyOwnerQuestion = false;
            this.errorMessageVisible = true;
            this.errorMessage = this.translocoService.translate('errors.invalidPAPRegistrationNumber');
          }
        }, error => {
          this.proceedEnabled = false;
          this.errorMessageVisible = true;
          this.errorMessage = this.translocoService.translate('errors.errorValidatingCSMCPAPRegistrationNumber');
        });
    } else {
      this.proceedEnabled = false;
    }
  }

  onPropertyOwnerChange() {

    // 🔁 HARD RESET (ONCE)
    this.selectDocumentType = false;
    this.selectDocumentType2 = false;
    // this.uploadFileVisible = false;
    // this.secondUploadFileVisible = false;

    // this.selectedDocumentType = null;
    // this.otherDocumentType = null;

    // this.applicantFileBase64 = null;
    // this.ownerFileBase64 = null;
    this.firstFileObj = null;
    this.secondFileObj = null;

    this.proceedEnabled = false;
    this.dirtyForm = true;

    // ✅ PROPERTY OWNER = YES
    if (this.isPropertyOwner === 'Property Owner') {
      this.selectDocumentType = true;
    }

    // ✅ PROPERTY OWNER = NO
    if (this.isPropertyOwner === 'Not A Property Owner') {
      this.selectDocumentType = true;
      this.selectDocumentType2 = true;
    }

    this.evaluateProceed();
  }


  setOwnerFileObj(file: File) {
    this.evaluateProceed();
  }



  onDocumentSelected() {

    this.uploadFileVisible = false;
    this.applicantFileBase64 = null;
    // this.firstFileObj = null;


    this.secondUploadFileVisible = false;
    this.proceedEnabled = false;
    this.dirtyForm = true;

    if (this.selectedDocumentType !== 'OTHER') {
      this.otherDocumentType = null;
    }

    // if (!this.selectedDocumentType) return;

    // First upload
    if (this.selectedDocumentType !== 'OTHER') {
      this.uploadFileVisible = true;
    }

    if (
      this.selectedDocumentType === 'OTHER' &&
      this.otherDocumentType?.trim()
    ) {
      this.uploadFileVisible = true;
    }

    // ❌ REMOVE second upload logic from here

    this.evaluateProceed();
  }


  onOtherDocumentTypeChange() {
    this.dirtyForm = true;

    if (
      this.selectedDocumentType === 'OTHER' &&
      this.otherDocumentType &&
      this.otherDocumentType.trim().length > 0
    ) {
      // ✅ ONLY FIRST UPLOAD
      this.uploadFileVisible = true;

      // ❌ DO NOT SHOW SECOND UPLOAD HERE
      this.secondUploadFileVisible = false;
      this.ownerFileBase64 = null;
      this.secondFileObj = null;

    } else {
      this.uploadFileVisible = false;
      this.secondUploadFileVisible = false;
    }

    this.evaluateProceed();
  }


  onOwnerDocumentSelected() {
    this.secondUploadFileVisible = false;
    this.ownerFileBase64 = null;
    this.secondFileObj = null;

    if (this.selectedOwnerDocumentType === 'DEATH_CERTIFICATE') {
      this.secondUploadFileVisible = true;
    }

    this.evaluateProceed();
  }



  onFirstFileUpload(file: File) {
    this.firstFileObj = file;
    const reader = new FileReader();
    reader.readAsDataURL(this.firstFileObj);
    reader.onload = () => {
      this.applicantFileBase64 = reader.result as string;
      this.evaluateProceed();

    }
  }

  onSecondFileUpload(file: File) {
    this.secondFileObj = file;
    const reader = new FileReader();
    reader.readAsDataURL(this.secondFileObj);
    reader.onload = () => {
      this.ownerFileBase64 = reader.result as string;
      this.evaluateProceed();
    }

  }




  fetchPAPCertificate() {
    // this.ownerFileBase64 = null;
    // this.secondFileObj = null;

    this.registrationStepService.fetchQuestionDoc(this.questionCode)
      .subscribe((data) => {

        if (data.status === "SUCCESS" && data.fileBase64) {

          const byteArray = new Uint8Array(
            atob(data.fileBase64).split("").map(c => c.charCodeAt(0))
          );
          const blob = new Blob([byteArray], { type: "image/png" });

          this.uploadFileVisible = true;
          this.selectDocumentType = true;
          this.firstSelectedImage = URL.createObjectURL(blob);
          this.applicantFileBase64 = data.fileBase64;


        } else {
          this.uploadFileVisible = false;
          this.selectedImage = "";
        }

        this.evaluateProceed();

      }, error => {
        this.uploadFileVisible = false;
        this.selectedImage = "";
      });
  }

  async proceed() {
    if (this.dirtyForm) {
      if (this.evaluateProceed()) {
        this.displayProgressSpinner();
        this.questionRequest = {
          projectAffectedPeopleRequest: {
            answer: this.selectedRadioOption,
            registrationNo: this.selectedRadioOption === 'Yes' ? this.registrationNo : null,
            isPropertyOwner: this.isPropertyOwner,
            selectedDocumentType: this.selectedDocumentType,
            selectedDocumentType2: this.selectedOwnerDocumentType,
            otherDocumentType: this.otherDocumentType,
            applicantFileBase64: this.applicantFileBase64,
            ownerFileBase64: this.ownerFileBase64
          }
        };
        this.registrationStepService.saveQuestion(this.questionCode, this.questionRequest)
          .subscribe((data) => {
            this.closeProgressSpinner();
            if (data.status === 'SUCCESS') {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }
            else {
              this.registrationStepService.showErrorMessage(data.errorMessage, true);
            }
          }, error => {
            console.log(error);
            this.closeProgressSpinner();
            this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
          });
      }
      else {
        this.registrationStepService.frontendWarningToast("error-mandatory-fields", false);
      }
    }
    else {
      this.displayProgressSpinner();
      this.registrationStepService.proceedWithoutSave(this.questionCode)
        .subscribe((data) => {
          this.closeProgressSpinner();
          if (data.status === 'SUCCESS') {
            if (data.questionCode) {
              localStorage.setItem("editQuestionCode", data.questionCode);
              this.proceedNext.emit();
            }
            else {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }
          }
          else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }
        }, error => {
          console.log(error);
          this.closeProgressSpinner();
          localStorage.removeItem("editQuestionCode");
          this.proceedNext.emit();
        });
    }
  }

  radioButtonClicked(event) {
    this.dirtyForm = true;

    // FULL RESET
    this.showPAPTextBox = false;
    this.showPropertyOwnerQuestion = false;
    this.selectDocumentType = false;
    this.selectDocumentType2 = false;
    this.uploadFileVisible = false;
    this.secondUploadFileVisible = false;

    this.registrationNo = null;
    this.isPropertyOwner = null;
    // this.selectedDocumentType = null;
    this.otherDocumentType = null;

    this.applicantFileBase64 = null;
    this.ownerFileBase64 = null;
    this.firstFileObj = null;
    this.secondFileObj = null;

    if (event === 'Yes') {
      this.showPAPTextBox = true;
    }
    else {
      if (this.selectedRadioOption == "No") {
        const msg = this.translocoService.translate('alerts.notPAP');
        alert(msg);
        this.proceedEnabled = false;
      }
    }

    this.evaluateProceed();
  }





  setSelectedImage(event) {
    this.selectedImage = event;
  }


  setOcrStatus(event) {
    this.ocrStatus = event;
  }

  setOcrEntryKey(event) {
    this.ocrEntryKey = event;
  }

  routeToCertEntryFn() {
    this.routeToCertEntry.emit();
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async closeProgressSpinner() {
    if (this.progressSpinnerDialog) {
      this.progressSpinnerDialog.close();
    }
  }

  evaluateProceed() {
    this.proceedEnabled = false;

    // STEP 1: PAP answer YES
    if (this.selectedRadioOption === 'Yes') {

      // Registration no mandatory
      if (!this.registrationNo || !this.registrationNo.trim()) return false;
      if (this.errorMessageVisible) return false;

      // Property owner mandatory
      if (!this.isPropertyOwner) return false;

      // Document type mandatory
      if (!this.selectedDocumentType) return false;

      // OTHER document → description mandatory
      if (
        this.selectedDocumentType === 'OTHER' &&
        (!this.otherDocumentType || !this.otherDocumentType.trim())
      ) {
        return false;
      }

      // Applicant file mandatory
      if (!this.applicantFileBase64) return false;

      // Owner file mandatory ONLY when Not A Property Owner
      if (
        this.isPropertyOwner === 'Not A Property Owner' &&
        !this.ownerFileBase64
      ) {
        return false;
      }

      // ✅ All conditions satisfied
      this.proceedEnabled = true;
      return true;
    }

    // STEP 2: Answer NO (existing logic if any)
    if (this.selectedRadioOption === 'No') {
      return false;
    }

    return false;


  }


  formatApplicationNo(value: string) {
    this.registrationNo = value.toUpperCase();
  }

  firstFileObj: File | null = null;
  secondFileObj: File | null = null;


  private rebuildPAPUIForEdit() {

    // Always show property owner question
    this.showPropertyOwnerQuestion = true;

    if (this.applicantFileBase64) {
      const byteArray = new Uint8Array(
        atob(this.applicantFileBase64).split('').map(c => c.charCodeAt(0))
      );
      const blob = new Blob([byteArray], { type: 'image/png' });

      this.firstSelectedImage = URL.createObjectURL(blob);
    }

    // Applicant document
    if (this.applicantFileBase64) {
      this.selectDocumentType = true;
      this.uploadFileVisible = true;
    }

    // Owner document
    if (this.isPropertyOwner === 'Not A Property Owner') {
      this.selectDocumentType2 = true;

      if (this.ownerFileBase64) {
        const byteArray = new Uint8Array(
          atob(this.ownerFileBase64).split("").map(c => c.charCodeAt(0))
        );
        const blob = new Blob([byteArray], { type: "image/png" });

        this.secondSelectedImage = URL.createObjectURL(blob);
        this.secondUploadFileVisible = true;
      }
    }

    this.evaluateProceed();
  }


}